<template>
  <div class="w-100">
    <div :id="itemModel.vars.id">
      <div
        :class="
          'd-flex align-items-center mb-2 ' + (itemModel.vars.label ? 'justify-content-between' : 'justify-content-end')
        "
      >
        <label
          v-if="itemModel.vars.label"
          :class="
            'form-label' +
            (itemModel.vars.label_attr && itemModel.vars.label_attr.class
              ? ' ' + itemModel.vars.label_attr.class
              : '') +
            (itemModel.vars.required ? ' required' : '')
          "
        >
          {{ index ? index + ". " : "" }}{{ itemModel.vars.label }}{{ itemModel.vars.required ? "*" : "" }}
          <span v-if="itemModel.vars.help && !isMobile()" v-tooltip="{ title: itemModel.vars.help, textWrap: true }">
            <FontAwesomeIcon icon="fa-light fa-circle-question" />
          </span>
        </label>
        <div>
          <button
            v-if="itemModel?.vars?.attr && itemModel.vars.attr['data-filter']"
            type="button"
            v-tooltip="{ title: $t('search_motor') }"
            class="btn btn-success filter"
            @click="openFilter"
          >
            <FontAwesomeIcon icon="fa-light fa-magnifying-glass" />
          </button>
          <button
            v-if="isFiltered"
            v-tooltip="{ title: $t('init_search') }"
            type="button"
            class="btn btn-success filter ms-2"
            @click="resetFilter"
          >
            <FontAwesomeIcon icon="fa-light fa-arrows-rotate" />
          </button>
        </div>
      </div>

      <div v-if="isMobile() && itemModel.vars.help" class="form-info">
        <FontAwesomeIcon icon="fa-light fa-circle-question" />
        {{ itemModel.vars.help }}
      </div>
      <div
        v-if="Object.keys(itemModel.vars.choices).length > 1 && !itemModel.vars.hide"
        class="mb-1 d-flex align-items-center justify-content-between"
      >
        <div>
          <button
            :class="'all textStyle ' + (itemModel.vars.disabled ? 'disabled' : '')"
            type="button"
            :disabled="(itemModel.vars.attr && itemModel.vars.attr.readonly) || itemModel.vars.disabled"
            @click="checkAll($event)"
          >
            {{ $t("All") }}
          </button>
          /
          <button
            :class="'none textStyle ' + (itemModel.vars.disabled ? 'disabled' : '')"
            type="button"
            :disabled="(itemModel.vars.attr && itemModel.vars.attr.readonly) || itemModel.vars.disabled"
            @click="checkNone($event)"
          >
            {{ $t("None") }}
          </button>
        </div>
        <div class="d-flex justify-content-end">
          <div
            v-if="itemModel.vars.attr && itemModel.vars.attr['data-archived-training-courses']"
            class="d-flex justify-content-end textStyle"
          >
            {{ $t("see_archive_training_courses") }}
            <SwitchTypeComponent :model="archiveModel" @update="archivedList" />
          </div>
          <div class="d-flex justify-content-end textStyle" v-if="grouped && !isBadgeFilterMode">
            {{ $t("trainingCoursesSelected") }}
            <SwitchTypeComponent :model="switchModel" @update="filterList" />
          </div>
        </div>
      </div>
      <div
        v-if="isBadgeFilterMode && availableBadges.length && !itemModel.vars.hide"
        class="badge-filters mb-2"
        role="group"
        :aria-labelledby="badgeFiltersLabelId"
      >
        <span :id="badgeFiltersLabelId" class="badge-filters__label textStyle">{{ $t("badgeFiltersLabel") }}</span>
        <button
          v-for="badge in availableBadges"
          :key="badge.label + '-' + (badge.type || '')"
          type="button"
          :class="[
            'badge-filter-btn',
            '-' + (badge.type ? badge.type : 'success'),
            { '-active': isBadgeActive(badge) },
          ]"
          :aria-pressed="isBadgeActive(badge) ? 'true' : 'false'"
          @click="toggleBadgeFilter(badge)"
        >
          <FontAwesomeIcon v-if="isBadgeActive(badge)" icon="fa-light fa-check" class="me-1" aria-hidden="true" />
          {{ badge.label }}
        </button>
        <p class="visually-hidden" role="status" aria-live="polite" aria-atomic="true">
          {{ $tc("badgeFiltersResultsCount", visibleChoicesCount, { count: visibleChoicesCount }) }}
        </p>
      </div>
      <div v-if="!grouped" class="choices-scroll" tabindex="0" :aria-label="$t('choicesScrollLabel')">
        <CheckboxInputComponent
          v-if="choices && choices.length && !itemModel.vars.hide"
          :choices="choices"
          :model="itemModel"
          @setChecked="setChecked"
          @focus="focus"
        />
        <div v-else-if="!itemModel.vars.hide" class="empty_data">
          {{ $t("global.empty.no_data_available") }}
        </div>
      </div>
      <div v-else class="" id="checkbox-accordion">
        <template v-for="(group, index) in choices" :key="group.group">
          <div class="group" v-if="groupIsVisible(group)">
            <h2 class="textStyle group__heading" :id="'heading-' + index">
              <span
                :data-bs-toggle="isAccordion() ? 'collapse' : ''"
                :data-bs-target="'#collapse-' + index"
                :aria-expanded="group.active"
                :aria-controls="'collapse-' + index"
                class="textStyle group__title"
                :class="{
                  collapsed: group.active,
                }"
                >{{ group.group }}</span
              >
              <div class="mb-1 d-flex align-items-center">
                <div class="textStyle group__controls" v-if="Object.keys(group.choices).length > 1">
                  <button
                    :class="'all textStyle ' + (itemModel.vars.disabled ? 'disabled' : '')"
                    type="button"
                    :disabled="(itemModel.vars.attr && itemModel.vars.attr.readonly) || itemModel.vars.disabled"
                    @click="check($event, true, index, group)"
                  >
                    {{ $t("All") }}
                  </button>
                  /
                  <button
                    :class="'none textStyle ' + (itemModel.vars.disabled ? 'disabled' : '')"
                    type="button"
                    :disabled="(itemModel.vars.attr && itemModel.vars.attr.readonly) || itemModel.vars.disabled"
                    @click="check($event, false, index, group)"
                  >
                    {{ $t("None") }}
                  </button>
                </div>
                <button
                  class="group__toggle"
                  :class="{
                    collapsed: !group.active,
                  }"
                  type="button"
                  :data-bs-toggle="isAccordion() ? 'collapse' : ''"
                  :data-bs-target="'#collapse-' + index"
                  :aria-expanded="group.active"
                  :aria-controls="'collapse-' + index"
                >
                  <FontAwesomeIcon class="ms-2 textStyle" v-if="isAccordion()" icon="fa-light fa-chevron-down" />
                </button>
              </div>
            </h2>
            <div
              :id="'collapse-' + index"
              class="accordion-collapse collapse choices-scroll"
              :class="{
                show: isAccordion() && group.active,
                collapse: isAccordion(),
                'accordion-collapse': isAccordion(),
              }"
              tabindex="0"
              :aria-label="group.group + ' — ' + $t('choicesScrollLabel')"
            >
              <CheckboxInputComponent
                :choices="group.choices"
                :model="itemModel"
                :readonly="itemModel.vars.attr && itemModel.vars.attr.readonly"
                :filtered="filtered"
                :archivedFilter="archivedFilter"
                :badgeFilterMode="isBadgeFilterMode"
                :selectedBadges="activeBadges"
                @setChecked="setChecked"
                @focus="focus"
              />
            </div>
          </div>
        </template>
        <div v-if="isBadgeFilterMode && !hasVisibleGroups" class="empty_data" role="status" aria-live="polite">
          {{ $t("global.empty.no_data_available") }}
        </div>
      </div>
    </div>
    <div v-if="error" class="invalid-feedback d-block">
      {{ error }}
    </div>
  </div>
</template>

<script>
import { formValidator } from "@/services/form/form-validator";
import { toRaw } from "vue";
import CheckboxInputComponent from "@/components/form/CheckboxInputComponent.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { formManager } from "@/services/form/form-manager";
import SwitchTypeComponent from "@/components/form/SwitchTypeComponent.vue";
import { stringManager } from "@/services/utilities/string-manager";
import { checkboxChoiceVisibilityManager } from "@/services/utilities/checkbox-choice-visibility-manager";

export default {
  name: "CheckboxTypeComponent",
  data() {
    return {
      itemModel: this.model,
      grouped: false,
      choices: [],
      filtered: false,
      archivedFilter: false,
      activeBadges: [],
      error: null,
      switchModel: {
        vars: {
          label: "",
          value: false,
        },
      },
      archiveModel: {
        vars: {
          label: "",
          value: false,
        },
      },
    };
  },
  emits: ["draft", "filter", "focus", "resetFilter", "toggle", "update"],
  props: {
    model: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: false,
      default: null,
    },
    isMultipleCheckbox: {
      type: Boolean,
      required: false,
      default: false,
    },
    isFiltered: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    isBadgeFilterMode() {
      return !!(this.itemModel.vars.attr && this.itemModel.vars.attr["data-badge-filter"]);
    },

    availableBadges() {
      if (!this.isBadgeFilterMode || !this.grouped) {
        return [];
      }
      const badgesByLabel = new Map();
      this.choices.forEach((group) => {
        Object.values(group.choices ?? []).forEach((choice) => {
          if (choice.badges && choice.badges.length) {
            choice.badges.forEach((badge) => {
              const key = badge.label.toLowerCase();
              if (!badgesByLabel.has(key)) {
                badgesByLabel.set(key, badge);
              }
            });
          }
        });
      });
      return Array.from(badgesByLabel.values());
    },

    hasVisibleGroups() {
      if (!this.grouped) {
        return true;
      }
      return this.choices.some((group) => this.groupIsVisible(group));
    },

    badgeFiltersLabelId() {
      return (this.itemModel.vars.id || "checkbox") + "-badge-filters-label";
    },

    visibleChoicesCount() {
      if (!this.isBadgeFilterMode || !this.grouped) {
        return 0;
      }
      return this.choices.reduce(
        (total, group) =>
          total +
          Object.values(group.choices ?? []).filter((choice) => this.isChoiceVisibleForBadgeFilter(choice)).length,
        0,
      );
    },
  },
  watch: {
    "itemModel.vars.choices"() {
      this.processChoices();
    },

    "model.vars.value"() {
      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
    },
  },
  mounted() {
    this.processChoices();
  },
  methods: {
    setChecked(event = null) {
      this.itemModel.vars.value = this.itemModel.vars.choices;
      let valid = formValidator.validCheckbox(this.itemModel.vars.value);
      if (!valid && this.itemModel.vars.required && !this.isMultipleCheckbox) {
        this.itemModel.vars["error"] = this.$t("requiredField");
        this.error = this.itemModel.vars["error"];
      } else {
        this.error = null;
        delete this.itemModel.vars.error;
        if (event && event.target) {
          event.target.classList.add("is-valid");
        }
      }

      this.$emit("update", this.itemModel.vars.value);
      if (this.itemModel.vars.toggler_target) {
        this.$emit("toggle", this.itemModel);
      }
      this.$emit("draft", this.itemModel);
    },

    isAccordion() {
      return formManager.isAccordion(this.itemModel);
    },

    isMobile() {
      return window.innerWidth < 992;
    },

    focus() {
      this.$emit("focus");
    },

    checkAll(e) {
      this.check(e, true);
      if (this.isAccordion()) {
        const collapses = document.querySelectorAll(".group__toggle.collapsed");
        for (let i = 0; i < collapses.length; i++) {
          if (collapses[i].classList.contains("collapsed")) {
            collapses[i].click();
            setTimeout(() => {
              collapses[i].classList.remove("collapsed");
            }, 50);
          }
        }
      }
    },

    checkNone(e) {
      this.check(e, false);
    },

    check(event, value, index = null, group = null) {
      event.stopPropagation();
      event.preventDefault();
      if (group) {
        group.active = value;
      }
      if (this.itemModel && this.itemModel.vars.choices && Object.keys(this.choices).length) {
        if (typeof index !== "number") {
          Object.values(this.choices).forEach((choice) => {
            if (this.grouped) {
              choice.choices.forEach((option) => {
                if (option && typeof option === "object" && !option.disabled && this.isChoiceCheckable(option)) {
                  option.checked = value;
                }
              });
            } else {
              if (choice && typeof choice === "object" && !choice.disabled && this.isChoiceCheckable(choice)) {
                choice.checked = value;
              }
            }
          });
        } else {
          Object.values(this.choices[index].choices).forEach((option) => {
            if (!option.disabled && this.isChoiceCheckable(option)) {
              option.checked = value;
            }
          });
        }
        this.setChecked();
      }
    },

    isChoiceCheckable(option) {
      return checkboxChoiceVisibilityManager.isVisible(option, {
        filtered: this.filtered,
        selectedBadges: this.activeBadges,
        archivedFilter: this.archivedFilter,
      });
    },

    filterList(value) {
      this.filtered = value;
      if (value) {
        this.choices.forEach((group) => {
          if (Object.values(group.choices).some((choice) => choice.checked)) {
            group.active = true;
          }
        });
      } else {
        this.choices.forEach((group) => {
          group.active = false;
        });
      }
    },

    toggleBadgeFilter(badge) {
      const label = badge.label.toLowerCase();
      const index = this.activeBadges.indexOf(label);
      if (index === -1) {
        this.activeBadges.push(label);
      } else {
        this.activeBadges.splice(index, 1);
      }
      this.updateGroupsVisibility();
    },

    isBadgeActive(badge) {
      return this.activeBadges.includes(badge.label.toLowerCase());
    },

    updateGroupsVisibility() {
      if (this.isAccordion()) {
        return;
      }
      this.choices.forEach((group, index) => {
        group.active = this.activeBadges.length
          ? Object.values(group.choices).some((choice) => this.isChoiceVisibleForBadgeFilter(choice))
          : this.isDefaultActiveGroup(group, index);
      });
    },

    // Sans filtre actif, on revient à l'affichage par défaut construit par processChoices :
    // premier accordéon ouvert, et tout groupe contenant au moins un choix coché.
    isDefaultActiveGroup(group, index) {
      return !index || Object.values(group.choices).some((choice) => choice.checked);
    },

    isChoiceVisibleForBadgeFilter(choice) {
      return checkboxChoiceVisibilityManager.isVisible(choice, {
        selectedBadges: this.activeBadges,
        archivedFilter: this.archivedFilter,
      });
    },

    groupIsVisible(group) {
      if (!this.isBadgeFilterMode) {
        return true;
      }
      if (!this.activeBadges.length) {
        return true;
      }
      return Object.values(group.choices).some((choice) => this.isChoiceVisibleForBadgeFilter(choice));
    },

    pruneActiveBadges() {
      if (!this.grouped) {
        return;
      }
      if (!this.activeBadges.length) {
        return;
      }
      const available = new Set();
      this.choices.forEach((group) => {
        Object.values(group.choices ?? []).forEach((choice) => {
          if (choice.badges) {
            choice.badges.forEach((badge) => available.add(badge.label.toLowerCase()));
          }
        });
      });
      this.activeBadges = this.activeBadges.filter((label) => available.has(label));
    },

    processChoices() {
      let choices = Object.values(this.itemModel.vars.choices);
      let index = 0;

      // Rejouée par le watcher sur `itemModel.vars.choices` (filtrage) : sans cette remise à
      // zéro, les groupes construits plus bas s'empilent sur ceux du rendu précédent.
      this.choices = [];
      this.grouped = false;

      if (choices && choices.length) {
        choices.forEach((choice) => {
          if (formManager.isEntityType(this.itemModel)) {
            let data;
            if (this.itemModel.vars.data) {
              data = this.itemModel.vars.data.find((item) => item.id === choice.data.id);
            }
            if (data) {
              choice.checked = true;
            }
          } else if (this.itemModel.vars.data && this.itemModel.vars.data.length) {
            choice.checked = this.itemModel.vars.data && this.itemModel.vars.data.includes(choice.data);
          }
          if (choice.choices && Object.keys(choice.choices).length) {
            let active = false;
            Object.values(choice.choices).forEach((choice) => {
              choice.checked = this.itemModel.vars.data && this.itemModel.vars.data.includes(choice.data);

              this.checkArchived(choice);

              const regex = /__(.+?)__/g;
              const matches = [...choice.label.matchAll(regex)];

              if (matches.length > 0) {
                choice.badges = matches.map((matche) => {
                  const content = matche[1];

                  const parts = content.match(/^(.+?)(?:-(.+))?$/);
                  let base;
                  let suffix;

                  if (parts && stringManager.VALID_BACKGROUND_CLASS.includes(parts[2])) {
                    base = parts[1];
                    suffix = parts[2];
                  } else {
                    base = content;
                    suffix = undefined;
                  }

                  const badge = { label: base };

                  if (suffix !== undefined) {
                    badge.type = suffix;
                  }

                  return badge;
                });

                choice.label = choice.label.replace(regex, "").replace(/\s+/g, " ").trim();
              }
              if (!active) {
                active = !index || choice.checked || choice.badge;
              }
              index++;
            });
            this.choices.push({
              group: choice.label,
              active: active,
              choices: Object.values(toRaw(choice.choices)),
            });
            this.grouped = true;
          }
        });

        if (!this.grouped) {
          this.choices = choices;
        }
      } else {
        this.choices = [];
      }
      this.itemModel.vars.value = this.choices;
      if (this.isBadgeFilterMode) {
        this.pruneActiveBadges();
        if (this.activeBadges.length) {
          this.updateGroupsVisibility();
        }
      }
    },

    checkArchived(choice) {
      if (this.itemModel.vars.attr && this.itemModel.vars.attr["data-archived-training-courses"]) {
        const regex = /--(.+?)--/g;
        const matches = [...choice.label.matchAll(regex)];
        if (matches.length > 0) {
          if (matches[0][1] === "archived") {
            choice.class = "text-danger";
            choice.archived = true;
            choice.label = choice.label.replace(regex, "").replace(/\s+/g, " ").trim();
          }
        }
      }
    },

    archivedList(value) {
      this.archivedFilter = value;
    },

    openFilter() {
      this.$emit("filter", this.itemModel.vars.attr["data-filter-target"]);
    },

    resetFilter() {
      this.$emit("resetFilter");
    },
  },
  components: {
    SwitchTypeComponent,
    FontAwesomeIcon,
    CheckboxInputComponent,
  },
};
</script>

<style lang="scss" scoped>
.choices-scroll {
  max-height: 9.375rem;
  overflow-y: auto;
  scrollbar-width: thin;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: $m-color_3;
    border-radius: 3px;

    @include dark-theme {
      background-color: $m-color_11;
    }
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }
}

.all,
.none {
  padding: 0;
  background: none;
  border: none;

  &:hover {
    text-decoration: underline;
  }
}

.group {
  margin-top: 15px;

  &__heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    background: none;
    border: none;
    border-bottom: 1px dashed $m-color_4;
    width: 100%;
  }

  &__title {
    margin-right: 15px;
    position: relative;
    font-size: 18px;
    width: 100%;
    flex: 1;
    cursor: pointer;
  }

  &__controls {
    font-size: 14px;
  }

  &__toggle {
    background: none;
    border: none;

    svg {
      transform: rotate(180deg);
      transition: all 300ms ease-in-out;
    }

    &.collapsed {
      svg {
        transform: rotate(0);
      }
    }
  }
}

#duplication_trainingCourseDestination {
  position: absolute;
  top: 0;
  width: 50%;

  @include up-to-md {
    position: relative;
    width: 100%;
  }
}

.empty_data {
  color: $light-grey;
}

.disabled {
  cursor: not-allowed;

  &:hover {
    text-decoration: none;
  }
}

.form-label {
  margin-bottom: 0;
}

.filter {
  svg {
    width: 15px;
    height: 15px;
  }
}

.badge-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;

  &__label {
    margin-right: 2px;
  }
}

.badge-filter-btn {
  display: inline-flex;
  align-items: center;
  border: 1px solid $m-color_3;
  border-radius: 4px;
  padding: 2px 10px;
  font-size: 12px;
  font-weight: 600;
  background-color: $white;
  color: $dark;
  cursor: pointer;

  &:focus-visible {
    outline: 2px solid $blue;
    outline-offset: 2px;
  }

  @include dark-theme {
    background-color: transparent;
    color: $white;
  }

  // Couleurs de fonctionnalité respectant un contraste RGAA >= 4,5:1 texte / >= 3:1 bordure :
  // $success/$warning/$danger d'origine sont sous ce seuil en texte blanc (état actif) comme
  // en texte/bordure de couleur sur fond blanc (état inactif) -> on utilise leurs déclinaisons
  // $d-* (cf. MailStatusChipComponent). $primary et $info respectent déjà le seuil.
  @each $name, $lightColor, $darkColor in (primary, $primary, $l-primary), (success, $d-success, $l-success),
    (warning, $d-warning, $l-warning), (danger, $d-danger, $l-danger), (info, $info, $l-info)
  {
    &.-#{$name} {
      border-color: $lightColor;
      color: $lightColor;

      &.-active {
        background-color: $lightColor;
        color: $white;
      }

      // Le sélecteur générique `body.dark .badge-filter-btn` a une spécificité supérieure à
      // `.badge-filter-btn.-#{$name}` : sans redéfinir la couleur ici, tous les badges
      // inactifs perdent leur couleur de fonctionnalité en thème sombre (texte blanc uniforme).
      @include dark-theme {
        border-color: $darkColor;
        color: $darkColor;

        &.-active {
          color: $white;
        }
      }
    }
  }
}
</style>
